<template>
  <el-dialog
    :modal-append-to-body="false"
    :append-to-body="true"
    title="房間概覽"
    :visible.sync="dialogVisible"
    width="80%"
    top="2%"
  >
    <div style="margin-bottom: 20px">
      Start Date:
      <el-date-picker
        v-model="date"
        size="small"
        type="date"
        placeholder="選擇日期"
      ></el-date-picker>
    </div>
    <div style="margin-bottom: 20px">
      Room Type:
      <el-checkbox-group v-model="type1" style="display: inline-block">
        <el-checkbox v-for="t in typeList2" :label="t.value" :key="t.value">{{
          t.label
        }}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div>
      Room State:
      <el-radio v-model="state" label="1">Vacant Clean</el-radio>
      <el-radio v-model="state" label="0">Not Vacant Clean</el-radio>
    </div>

    <el-table
      :key="tableKey"
      stripe
      :data="tableData"
      style="width: 100%; color: black"
      ref="multipleTable"
    >
      <el-table-column label="Date">
        <template slot-scope="scope">
          <span>{{ scope.row.Date }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Total" prop="Total" />
      <template v-for="col in column">
        <el-table-column
          :key="col.label"
          align="center"
          :label="col.label"
          :prop="col.model"
        />
      </template>
    </el-table>
    <p style="text-align: center; margin-top: 20px">第{{ currentPage }}頁</p>
    <el-pagination
      style="text-align: center"
      background
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="sizes, prev, pager, next"
    >
    </el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="dialogVisible = false"
        >关闭</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { getPageList } from "@/api/guest/appointment";
export default {
  props: {
    typeList2: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableKey: true,
      typeList: [],
      initCols: [],
      dialogVisible: false,
      date: "",
      type1: ["3", "4"],
      state: "1",
      tableData: [],
      size: 10,
      currentPage: 1,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    column() {
      return this.initCols;
    },
  },
  watch: {
    column: {
      handler() {
        this.tableKey = !this.tableKey;
      },
      deep: true,
    },
    date: {
      handler() {
        this.getList();
      },
      deep: true,
    },
    type1: {
      handler() {
        this.getList();
      },
      deep: true,
    },
    state: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    visit() {
      this.dialogVisible = true;
      this.getList();
    },
    getList() {
      getPageList({
        StartDate: this.date,
        RoomType: this.type1.join(","),
        RoomStatus: this.state,
        PageIndex: this.currentPage,
        PageSize: this.size,
      }).then((res) => {
        this.tableData = res.data.Data;
        this.initCols = res.data.Header.filter(
          (_) => _.Code != "date" && _.Code != "total"
        ).map((_) => {
          return {
            label: _.Display,
            model: _.BindDataColumn,
          };
        });
        this.typeList = this.initCols.map((_) => _.label);
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
  },
};
</script>
